import React, { useState, useContext } from 'react';
import Identity from '../../components/Identity';
import Form from 'react-bootstrap/Form';
import { DataContext } from './../../App';

export default function Wichtigeangaben(params) {
  let [page, setPage] = useState(0);
  const { zustandDerImmobilie, setZustandDerImmobilie } =
    useContext(DataContext);
  const { derzeitigeNutzung, setDerzeitigeNutzung } = useContext(DataContext);

  let previousPage = () => {
    setPage(0);
  };

  return (
    <>
      {page === 0 && (
        <>
          <h2>
            <strong>NOCH 2 WICHTIGE ANGABEN</strong>
            <hr />
          </h2>

          <div className='choices-list-two flex-container'>
            <div className='choice choice-2'>
              <Form.Select
                value={zustandDerImmobilie}
                onChange={(e) => setZustandDerImmobilie(e.target.value)}
                aria-label='Default select example'
              >
                <option value='RENOVIERUNGSBEDÜRFTIG'>
                  RENOVIERUNGSBEDÜRFTIG
                </option>
                <option value='EINFACH'>EINFACH</option>
                <option value='GEPFLEGT'>GEPFLEGT</option>
                <option value='GEHOBEN'>GEHOBEN</option>
                <option value='LUXUS'>LUXUS</option>
              </Form.Select>
              <p>ZUSTAND DER IMMOBILIE</p>
            </div>
            <div className='choice choice-2'>
              <Form.Select
                value={derzeitigeNutzung}
                onChange={(e) => setDerzeitigeNutzung(e.target.value)}
                aria-label='Default select example'
              >
                <option value='LEERSTEHEND'>LEERSTEHEND</option>
                <option value='SELBSTBEWOHNT'>SELBST BEWOHNT</option>
                <option value='VERMIETET'>VERMIETET</option>
              </Form.Select>
              <p>DERZEITIGE NUTZUNG</p>
            </div>
          </div>
          <div className='buttons'>
            <button className='previous' onClick={params.previousPage}>
              Zurück
            </button>
            <button className='next' onClick={() => setPage(1)}>
              Weiter
            </button>
          </div>
        </>
      )}
      {page === 1 && <Identity previousPage={previousPage} />}
    </>
  );
}
